module.exports = __webpack_public_path__ + "static/media/retail-attribution.94eba87d.png";